import { format } from 'date-fns';

export const formatDate = (dateString: string | null | undefined): string => {
  if (!dateString) return '-';
  try {
    return format(new Date(dateString), 'dd.MM.yyyy');
  } catch {
    return dateString;
  }
};

export const formatDateTime = (dateString: string | null) => {
  if (!dateString) return null;
  try {
    const date = new Date(dateString);
    return {
      date: format(date, 'dd.MM.yyyy'),
      time: format(date, 'HH:mm'),
    };
  } catch {
    return null;
  }
};

export const formatDateTimeStored = (dateString: string | null) => {
  if (!dateString) return null;
  const m = dateString.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/);
  if (!m) return null;
  const [, y, mo, d, h, min] = m;
  return {
    date: `${d}.${mo}.${y}`,
    time: `${h}:${min}`,
  };
};
